import '../../App.point.css';
import React, { Component } from 'react';
import fn_set_footer from './StdtMenuCmp';
import $ from 'jquery';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, AlertModal, udfLogOut } from '../../common/common';
import loader from '../../imgs/ajax-loader.gif';
import { Navbar, ListGroup, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

let firstIndex = 0;	// 불러 올 시작 레코드
const recordCountPerPage = 10;	// 한번에 불러 올 레코드 개수
let isMore = true;	// 불러 올 레코드 존재 여부
let isRunning = false;
let isLogging = false;

class NoticeCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      list: [],
      usrInfo: null,
    };
  }

  componentDidMount = () => {
    if (!isRunning && !isLogging) {
      isLogging = true;
      // 자동 로그인 체크
      udfAutoLogin(this).then((data) => {
        isRunning = false;
        isLogging = false;
        if (data !== null && data.userSe === 'STDT') {
          this.setState({ usrInfo: data });
          this.udfSelectList('Y');
        } else if (data !== null && data.userSe === 'USR') {
          this.props.history.push('/menuList');
        } else {
          this.props.history.push('/');
        }
      });
    }

    // 로그아웃 버튼 바인딩
    document.getElementById("logoutBtn").addEventListener('click', () => { udfLogOut(this) });
    // 뒤로 이동 버튼 바인딩
    $('.goBackBtn').on('click', () => {
      if (this.props.history !== null && typeof (this.props.history) !== undefined) this.props.history.go(-1);
    });
  }

  componentWillUpdate = () => {
    $('a[role="tab"]').addClass('col text-center pl-2 pr-2');
  }

  handleScroll = () => {
    if ($('.wrap-loading').length - $('.wrap-loading.d-none').length !== 0 || $('.modal-backdrop.show').length > 0)
      return false;

    let marginBottom = 71;
    if (window.innerHeight + marginBottom >= Math.ceil(document.getElementsByTagName('body')[0].getBoundingClientRect().bottom) && isMore) {
      this.udfSelectList('N');
    }
  }

  udfSelectList = (clearYn) => {
    if (!this.state.usrInfo || isLogging) return;

    if (clearYn === 'Y') {
      isMore = true;
      firstIndex = 0;
    }

    let setData = {
      isMobile: 'Y',
      firstIndex: firstIndex,
      recordCountPerPage: recordCountPerPage,
      bbsId: 'BBSMSTR_000000000002'
    };

    if (isMore && !isRunning) {
      udfInlineLoading();
      isRunning = true;

      const that = this;

      $.ajax({
        url: url + '/slp/stdt/selectBoardList.do',
        type: 'GET',
        dataType: 'jsonp',
        data: setData,
        success: function (data) {
          if (!data.success) {
            // that.componentDidMount();
          } else {
            if (data.list !== undefined && data.list !== null) {
              if (data.list.length !== recordCountPerPage)
                isMore = false;

              firstIndex = firstIndex + data.list.length;
              that.setState({
                isLoggedIn: true,
                list: that.state.list.concat(data.list)
              });
            }
          }

          isRunning = false;
          udfNoneLoading();
        },
        error: function (jqXHR, status, error) {
          isRunning = false;
          // that.componentDidMount();
          udfNoneLoading();
        }
      });
    }
  }

  render() {
    const list = this.state.list === null ? null :
      this.state.list.map((data, idx) => {
        if (data.useAt !== 'N') {
          let linkUrl = '/stdt/noticeArticle/BBSMSTR_000000000002/' + data.nttId;
          return (
            <Link to={linkUrl} key={idx}>
              <ListGroup.Item>
                <Row>
                  <Col>
                    {data.nttSj}
                    <div style={{ fontSize: '.9rem', color: 'gray' }}>{data.frstRegisterPnttm}</div>
                  </Col>
                  <Col style={{ maxWidth: '50px', textAlign: 'right' }}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </Col>
                </Row>
              </ListGroup.Item>
            </Link>
          );
        } else return null;
      });

    return (
      <>
        <AlertModal
          show={this.state.alertShow}
          onHide={this.alertClose}
          Title="스쿨라이프"
          Message={this.state.alertMessage}
          onClickOk={this.state.alertClickOk}
          onClickNo={this.state.alertClickNo}
          onClickYes={this.state.alertClickYes}
        />

        {/* loading image */}
        <div className="wrap-loading">
          <img src={loader} alt="로딩 이미지" />
        </div>

        {/* header */}
        <Navbar fixed="top" className="title">
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          학교공지
        </Navbar>

        <div className='container-fluid noScroll p-0' style={{ marginBottom: '71px' }}>
          <ListGroup className="p-0" variant='flush' style={{ marginTop: '55px', marginBottom: '4rem' }}>
            {list}
          </ListGroup>
        </div>

        {fn_set_footer('')}
      </>
    );
  }
}

export default NoticeCmp;